import supabase from '../supabase/supabase';

    /**
     * Service to handle Email interactions via Supabase Edge Functions.
     */
    export const sendInviteEmail = async (toEmail, fullName, role) => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        const appUrl = window.location.origin;
        const inviteLink = `${appUrl}/#/auth?email=${encodeURIComponent(toEmail)}&invite=true`;

        // Added a timeout controller to handle slow cold starts gracefully
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 20000); // 20s timeout

        const { data, error } = await supabase.functions.invoke('send-email', {
          headers: {
            Authorization: `Bearer ${session?.access_token}`,
          },
          body: {
            to: toEmail,
            subject: "You're invited to Zora's House Library!",
            htmlBody: `
              <div style="font-family: sans-serif; max-width: 600px; margin: auto; padding: 30px; border: 1px solid #eee; border-radius: 20px; color: #181844;">
                <div style="text-align: center; margin-bottom: 30px;">
                  <h2 style="text-transform: uppercase; letter-spacing: 2px; margin: 0;">Zora's House</h2>
                  <p style="text-transform: uppercase; font-size: 10px; letter-spacing: 4px; color: #268f99;">Library System</p>
                </div>
                <p>Hi <b>${fullName}</b>,</p>
                <p>You have been officially invited to join the <b>Zora's House Library</b> as a <b>${role.toUpperCase()}</b>.</p>
                <div style="margin: 40px 0; text-align: center;">
                  <a href="${inviteLink}" style="background-color: #268f99; color: white; padding: 16px 32px; text-decoration: none; border-radius: 12px; font-weight: bold; text-transform: uppercase; font-size: 12px; letter-spacing: 1px; display: inline-block; box-shadow: 0 4px 15px rgba(38,143,153,0.3);">
                    Accept Invitation & Create Account
                  </a>
                </div>
                <p style="font-size: 12px; color: #999; line-height: 1.6;">
                  If the button above doesn't work, copy and paste this link into your browser:<br>
                  <span style="color: #268f99;">${inviteLink}</span>
                </p>
              </div>
            `
          }
        });

        clearTimeout(timeoutId);
        if (error) {
          if (error.name === 'AbortError') throw new Error('The request timed out. Please check the invites list to see if it was recorded.');
          throw error;
        }

        return { success: true, data };
      } catch (error) {
        console.error('Email Service Error:', error);
        return { success: false, error: error.message };
      }
    };

    export const sendCheckoutEmail = async (toEmail, fullName, bookTitle, dueDate) => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        const { error } = await supabase.functions.invoke('send-email', {
          headers: { Authorization: `Bearer ${session?.access_token}` },
          body: {
            to: toEmail,
            subject: `Confirmed: You've borrowed "${bookTitle}"`,
            htmlBody: `
              <div style="font-family: sans-serif; max-width: 600px; margin: auto; padding: 20px; border: 1px solid #eee; border-radius: 10px;">
                <h2 style="color: #268f99; text-transform: uppercase; letter-spacing: 1px;">Checkout Confirmed</h2>
                <p>Hi ${fullName},</p>
                <p>You've successfully checked out <b>"${bookTitle}"</b>.</p>
                <p style="background: #f4f4f4; padding: 15px; border-radius: 8px; font-weight: bold;">
                  Please return by: ${dueDate}
                </p>
              </div>
            `
          }
        });
        if (error) throw error;
        return { success: true };
      } catch (error) {
        return { success: false, error: error.message };
      }
    };